import { FC } from 'react';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { BevoegdGezagCreate } from './routes/bevoegdgezag/create/page';
import { BevoegdGezagEdit } from './routes/bevoegdgezag/edit/page';
import { BevoegdGezagOverview } from './routes/bevoegdgezag/page';
import { BaseLayout } from './routes/layout';
import { Home } from './routes/page';
import { WebGebruikerOverview } from './routes/webgebruiker/page';
import { WebGebruikerCreate } from './routes/webgebruiker/create/page';
import { WebGebruikerEdit } from './routes/webgebruiker/edit/page';
import { DeelnemerOverview } from './routes/deelnemer/page';
import { PrivacyStatement } from './routes/privacy/page';
import { MilieudienstOverview } from './routes/milieudienst/page';
import { MilieudienstEdit } from './routes/milieudienst/edit/page';
import { DeelnemerCreate } from './routes/deelnemer/create/page';
import { DeelnemerEdit } from './routes/deelnemer/edit/page';
import { ClusterOverview } from './routes/cluster/page';
import { ClusterCreate } from './routes/cluster/create/page';
import { ClusterEdit } from './routes/cluster/edit/page';
import { ReportRequestOverview } from './routes/reportrequestlog/page';
import { Rekenregels } from './routes/rekenregels/page';
import { WatercoachPage } from './routes/watercoach/page';
import { WatercoachEditPage } from './routes/watercoach/edit/page';

export const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
};

const Routes = () => {
  const routes = useRoutes([
    {
      path: '',
      element: <BaseLayout />,
      children: [
        { element: <Home />, path: '/' },
        {
          path: '/privacy',
          children: [{ element: <PrivacyStatement />, path: '' }],
        },
        {
          path: '/bevoegdgezag',
          children: [
            { element: <BevoegdGezagOverview />, path: '' },
            { element: <BevoegdGezagCreate />, path: 'create' },
            { element: <BevoegdGezagEdit />, path: ':id' },
          ],
        },
        {
          path: '/webgebruiker',
          children: [
            { element: <WebGebruikerOverview />, path: '' },
            { element: <WebGebruikerCreate />, path: 'create' },
            { element: <WebGebruikerEdit />, path: ':id' },
          ],
        },
        {
          path: '/deelnemer',
          children: [
            { element: <DeelnemerOverview />, path: '' },
            { element: <DeelnemerCreate />, path: 'create' },
            { element: <DeelnemerEdit />, path: ':id' },
          ],
        },
        {
          path: '/milieudienst',
          children: [
            { element: <MilieudienstOverview />, path: '' },
            { element: <MilieudienstEdit />, path: ':id' },
          ],
        },
        {
          path: '/cluster',
          children: [
            { element: <ClusterOverview />, path: '' },
            { element: <ClusterCreate />, path: 'create' },
            { element: <ClusterEdit />, path: ':id' },
          ],
        },
        {
          path: '/report-request-log',
          children: [{ element: <ReportRequestOverview />, path: '' }],
        },
        {
          path: '/watercoach',
          children: [
            { element: <WatercoachPage />, path: '' },
            { element: <WatercoachEditPage />, path: ':id' },
          ],
        },
        {
          path: '/rekenregels',
          children: [{ element: <Rekenregels />, path: '' }],
        },
      ],
    },
  ]);
  return routes;
};
